import Eligibility from 'features/advance/screens/lightning/Eligibility/Eligibility';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function EligibilityPage() {
  return (
    <PinwheelContextProvider>
      <Eligibility />
    </PinwheelContextProvider>
  );
}
